<div class="radio input input--radio value--{{ value | ftrDasherize }}">
  <div class="radio__container">
    <input
      type="radio"
      [id]="id"
      class="input__control"
      [value]="value"
      [name]="name"
      [attr.name]="name"
      [formControl]="control"
      [attr.aria-describedby]="id + 'description'"
    />
    <label class="input__label" [class.input__label--stress]="!!(summary || summaryTemplate)" [for]="id">
      @if (label) {
        {{ label }}
      }
    </label>
    @if (summary) {
      <span class="input__summary" [id]="id + 'description'">{{ summary }}</span>
    }
    <ng-container *ngTemplateOutlet="summaryTemplate" />
  </div>
</div>
